import { useDataFetch } from "./useDataFetch";

/**
 * Funciones del panel que se prenden o apagan desde la tabla `setting` de la
 * base, sin volver a publicar el panel (ver back/database/migraciones/
 * 2026-09-30_ajustes.sql). El cambio se ve al recargar la página.
 *
 * Mientras no llega la respuesta, o si falla, todo se considera apagado: es
 * mejor no mostrar un momento algo que debía estar oculto.
 */
const useAjustes = () => {
  const { getData } = useDataFetch();
  const { data, isSuccess, isError } = getData(["ajustes"], "/panel/ajustes", {
    enabled: true,
  });

  return {
    cargando: !isSuccess && !isError,
    tiposDeArbol: isSuccess && data?.tree_types === true,
  };
};

export default useAjustes;
